ConversationsStore = require './abstract/ConversationsStore'
ActionTypes = require '../constants/ActionTypes'

class ConversationsMyStore extends ConversationsStore
  constructor: ->
    super()
    @registerActions()

  getActions: =>
    "#{ActionTypes.CONVERSATIONS_MY_GET_LIST_REQUESTING}": @onSearchInit
    "#{ActionTypes.CONVERSATIONS_MY_GET_LIST_SUCCESS}": @onSearchSuccess
    "#{ActionTypes.CONVERSATIONS_MY_GET_LIST_FAILURE}": @onSearchError
    "#{ActionTypes.CONVERSATIONS_MY_SEARCH_RESET}": @onSearchReset
    "#{ActionTypes.CONVERSATIONS_SET_DEFAULT_MY_STATE}": @onSetDefaultState
    "#{ActionTypes.MQTT_MY_ACTIVE_CONVERSATIONS_REQUEST}": @onConversationsRequest
    "#{ActionTypes.MQTT_MY_ACTIVE_CONVERSATIONS_UPDATING_INITIAL}": @onConversationsRequest
    "#{ActionTypes.MQTT_MY_ACTIVE_CONVERSATIONS_UPDATING}": @onConversationsUpdating

module.exports = new ConversationsMyStore()
